export default "__VITE_ASSET__B403sRnk__"